import React from 'react'

import { Box, Alert } from '@mui/material'

import CortexLogo from '../../assets/images/cortex-logo-vertical.png'

// Ported from kwik-assistant's App.js informational states, shown instead
// of the chat UI when the enterprise hasn't contracted Cortex or this user
// hasn't been granted access.
const AssistantAccessGate = ({ enterpriseHasAssistant, userHasAssistant }) => {
    if (!enterpriseHasAssistant) {
        return (
            <Box className="cortex-info-container">
                <img src={CortexLogo} alt="logo" className="cortex-teaser-logo" />
                <Alert severity="error">
                    Sua empresa ainda não contratou o Cortex. A ferramenta de IA da Instant Solutions.
                </Alert>
                <Alert severity="info" style={{ marginTop: '10px' }}>
                    Clique <a href="https://wa.me/551140636100">aqui</a> para contratar!
                </Alert>
            </Box>
        )
    }

    if (!userHasAssistant) {
        return (
            <Box className="cortex-info-container">
                <img src={CortexLogo} alt="logo" className="cortex-teaser-logo" />
                <Alert severity="error">
                    Você ainda não tem acesso ao Cortex.
                </Alert>
                <Alert severity="info" style={{ marginTop: '10px' }}>
                    Converse com seu supervisor e peça para ele ativar para você!
                </Alert>
            </Box>
        )
    }

    return null
}

export default AssistantAccessGate
